export const getProperPhoneNumber = (number) => {
  // returns 7772223344 format
  const result = String(number).replace(/\+7/g, '').replace(/\D+/g, '')

  if (result.length > 10) {
    return result.slice(1)
  }
  return result
}